const SWIPE_DISMISS_THRESHOLD = 50;

export const shouldDismissVerticalSwipe = (
  dx: number,
  dy: number,
  threshold = SWIPE_DISMISS_THRESHOLD,
): boolean => dy > threshold && Math.abs(dy) > Math.abs(dx);
